// Progression card for the calendar sidebar "phone" preview (type 'P').
// Copy of the workouts module's ProgressionCard; reuses the shared TBSelectBox (showing the
// mastered/working selection) with a no-op select fn. Interaction is blocked by the overlay.
import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import IcomoonReact from 'icomoon-react';

import TBSelectBox from '../../../../shared/components/TBSelectBox/TBSelectBox';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import { BoxShadow } from '../../../../shared/GlobalStyles';

const Container = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: ${BoxShadow};
  border-radius: 12px;
  background: white;
  padding-bottom: 20px;
  padding-top: 20px;
  height: auto;
`;

const ProgressionTitleText = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Nunito Sans';
  font-size: 12px;
  margin-bottom: 20px;
`;

const ProgressionAsteriskText = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Nunito Sans';
  font-size: 12px;
  margin-top: 20px;
  white-space: normal;
  padding-left: 10px;
  padding-right: 10px;
`;

const CompleteButton = styled('button')`
  width: 140px;
  height: 37px;
  border-radius: 40px;
  box-shadow: ${BoxShadow};
  border: 1px solid lightgrey;
  margin-top: 20px;
  background: white;
`;

const InnerCompleteButton = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CompleteButtonText = styled('div')`
  font-size: 12px;
  margin-left: 10px;
  font-weight: 600;
  font-family: 'Nunito Sans';
  color: black;
`;

const ButtonContainer = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const masteredProgressionOption = {
  inputLabel: 'I have mastered this',
  label: 'I have mastered this',
  value: true,
};

const stillWorkingProgressionOption = {
  inputLabel: 'I am still working on this',
  label: 'I am still working on this',
  value: false,
};

const progressionOptions = [masteredProgressionOption, stillWorkingProgressionOption];

const noop = () => {};

const CalendarProgressionCard = ({ workoutObject }) => {
  const defaultOption = workoutObject.progressionStepMastered
    ? masteredProgressionOption
    : stillWorkingProgressionOption;

  return (
    <Container>
      <ProgressionTitleText>Select current status for this step</ProgressionTitleText>
      <TBSelectBox
        list={progressionOptions}
        label='label'
        selectItemFunction={noop}
        defaultOption={defaultOption}
        headerWidthPercentage={80}
      />
      <ButtonContainer>
        <CompleteButton type='button'>
          <InnerCompleteButton>
            <IcomoonReact iconSet={iconSet} size={15} icon='checkmark' color='black' />
            <CompleteButtonText>Complete</CompleteButtonText>
          </InnerCompleteButton>
        </CompleteButton>
      </ButtonContainer>
      <ProgressionAsteriskText>
        *All Steps in a level must be completed to move on to the next level.
      </ProgressionAsteriskText>
    </Container>
  );
};

CalendarProgressionCard.propTypes = {
  workoutObject: PropTypes.instanceOf(Object).isRequired,
};

export default CalendarProgressionCard;
